import React, { createContext, useContext, useState } from "react";

const dict = {
  en: {
    tagline: "Make Parenting Joyful",
    book_consult: "Book Consultation",
    chat_wa: "Chat on WhatsApp",
    buy_ebooks: "Buy E-Books",
    watch_videos: "Watch Videos",
    login: "Login",
    signup: "Sign up",
    logout: "Logout",
    dashboard: "Dashboard",
    home: "Home",
    ebooks: "E-Books",
    content: "Content",
    trackers: "Trackers",
    contact: "Contact",
    about: "About",
  },
  hi: {
    tagline: "पालन-पोषण को आनंदमय बनाइए",
    book_consult: "कंसल्टेशन बुक करें",
    chat_wa: "व्हाट्सएप पर चैट",
    buy_ebooks: "ई-बुक्स खरीदें",
    watch_videos: "वीडियो देखें",
    login: "लॉगिन",
    signup: "साइन अप",
    logout: "लॉगआउट",
    dashboard: "डैशबोर्ड",
    home: "होम",
    ebooks: "ई-बुक्स",
    content: "कंटेंट",
    trackers: "ट्रैकर्स",
    contact: "संपर्क",
    about: "परिचय",
  },
};

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("dh_lang") || "en");
  const t = (k) => dict[lang][k] || dict.en[k] || k;
  const setLangSave = (l) => { setLang(l); localStorage.setItem("dh_lang", l); };
  return <LangCtx.Provider value={{ lang, t, setLang: setLangSave }}>{children}</LangCtx.Provider>;
}

export function useLang() { return useContext(LangCtx); }
